import React, { useState, useEffect } from "react";
import { Icon, useToast } from "@chakra-ui/react";
import { FiEdit3 } from "react-icons/fi";
import { MdCancel } from "react-icons/md";
import { BsCheckCircle } from "react-icons/bs";
import ResponsiveRow from "../../Common/Table/ResponsiveRow";
import { numberFormatter } from "../../../Utils/formatUtils";
import TdType from "../../Common/Table/TdType";

const ProductItem = ({
  product,
  initialAction = "row",
  updateProduct,
  isEditable = true,
  priceListProducts,
  setIsEdited = () => {},
}) => {
  const [action, setAction] = useState(initialAction);
  const [priceListProduct, setPriceListProduct] = useState(product);
  const toast = useToast();

  useEffect(() => {
    let foundProduct = priceListProducts.find(
      (pr) => pr.productId === product.id
    );
    if (foundProduct) {
      setPriceListProduct(foundProduct);
    } else {
      setPriceListProduct({
        ...product,
        productId: product.id,
        discount: 0,
        profit: 0,
        active: 0,
      });
    }
    if (action === "edit") setIsEdited(true);
  }, [action]);

  const validateForm = async () => {
    if (priceListProduct.profit < priceListProduct.discount) {
      toast({
        title: "Se ha producido un error.",
        description: "La ganancia es menor al descuento.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } else {
      await updateProduct(priceListProduct);
      setAction("row");
    }
  };

  const handleCancel = () => {
    setAction("row");
  };

  const handleSwitchChange = (val) => {
    if (priceListProduct.discount >= priceListProduct.profit) {
      toast({
        title: "Se ha producido un error.",
        description: "La ganancia es menor al descuento.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      setPriceListProduct({
        ...priceListProduct,
        active: 0,
      });
      return;
    }
    setPriceListProduct({
      ...priceListProduct,
      active: val.target.checked ? 1 : 0,
    });
  };

  const handleChange = (val) => {
    setPriceListProduct({
      ...priceListProduct,
      [val.target.id]: val.target.value,
    });
  };

  const handleEdit = () => {
    setAction("edit");
  };

  const handleSubmit = () => {
    validateForm();
  };

  const getDiscountPrice = () => {
    return numberFormatter(
      product.cost * (1 + priceListProduct.profit / 100) -
        (product.cost * priceListProduct.discount) / 100
    );
  };

  const getProfitPrice = () => {
    return numberFormatter(product.cost * (1 + priceListProduct.profit / 100));
  };

  const rowDisplay = () => {
    let rowData = [];
    // eslint-disable-next-line default-case
    switch (action) {
      case "edit":
        rowData = [
          {
            tdStyle: {
              width: "30%",
            },
            item: <TdType text={product.productName} />,
          },
          {
            tdStyle: {
              textAlign: "center",
              width: "12%",
              px: "2",
            },
            item: (
              <TdType
                inputType="input"
                isDisabled={true}
                id="cost"
                value={product.cost}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              width: "12%",
              px: "2",
            },
            item: (
              <TdType
                inputType="input"
                id="profit"
                value={priceListProduct.profit}
                onChange={handleChange}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              width: "12%",
              px: "2",
            },
            item: (
              <TdType
                inputType="input"
                isDisabled={true}
                id="profitPrice"
                value={getProfitPrice(priceListProduct)}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              width: "12%",
              px: "2",
            },
            item: (
              <TdType
                inputType="input"
                isDisabled={!priceListProduct.profit}
                id="discount"
                value={priceListProduct.discount}
                onChange={handleChange}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              width: "12%",
              px: "2",
            },
            item: (
              <TdType
                inputType="input"
                isDisabled={true}
                id="discountPrice"
                value={getDiscountPrice(priceListProduct)}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
            },
            item: (
              <TdType
                inputType="switch"
                id="active"
                isChecked={priceListProduct.active}
                onChange={handleSwitchChange}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              width: "15%",
              px: "2",
            },
            item: (
              <>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={BsCheckCircle}
                  color="green"
                  onClick={() => handleSubmit()}
                  title={"Aceptar"}
                ></Icon>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={MdCancel}
                  color="red"
                  title={"Cancelar"}
                  onClick={() => handleCancel()}
                ></Icon>
              </>
            ),
          },
        ];
        return (
          <ResponsiveRow
            key={product.productId}
            cells={rowData}
          ></ResponsiveRow>
        );
      case "row":
        rowData = [
          {
            tdStyle: {
              width: "30%",
            },
            item: <TdType text={product.productName} />,
          },
          {
            item: <TdType text={product.cost} />,
          },
          {
            item: <TdType text={numberFormatter(priceListProduct.profit)} />,
          },
          {
            item: <TdType text={getProfitPrice()} />,
          },
          {
            item: <TdType text={numberFormatter(priceListProduct.discount)} />,
          },
          {
            item: <TdType text={getDiscountPrice()} />,
          },
          {
            item: (
              <TdType
                inputType="switch"
                id="active"
                isChecked={priceListProduct.active}
                isDisabled={true}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              width: "15%",
              px: "2",
            },
            item: (
              <>
                {isEditable && (
                  <Icon
                    mx="2"
                    as={FiEdit3}
                    _hover={{ cursor: "pointer" }}
                    onClick={() => handleEdit(product)}
                    title={"Editar"}
                  ></Icon>
                )}
              </>
            ),
          },
        ];
        return <ResponsiveRow key={product.id} cells={rowData}></ResponsiveRow>;
    }
  };
  return <>{rowDisplay()}</>;
};

export default ProductItem;
